<template>
  <JobColumn :job-title="jobTitle" :job-id="hireId" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import {
  extractJobTitleWithFallback,
  extractHireIdWithFallback,
} from '@/components/Employments/Partner/EmploymentExportConfig'
import JobColumn from '@/components/GraphqlDataTable/columns/JobColumn.vue'

const EmploymentJobColumn = graphql(`
  fragment EmploymentJobColumn on Employment {
    id
    hires {
      data {
        number
        latestContract {
          id
          jobName
        }
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentJobColumn> }>()
const column = computed(() => useFragment(EmploymentJobColumn, props.row))

const jobTitle = computed(() => extractJobTitleWithFallback(column.value))
const hireId = computed(() => extractHireIdWithFallback(column.value))
</script>
